module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editReservationPopupBg d-flex flex-column align-items-center justify-content-center",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeSubModal($event)
      }
    }
  }, [_c('div', {
    staticClass: "popupArea bg-lightest p-3"
  }, [_c('div', {
    staticClass: "text-center fs-larger font-weight-600 p-3"
  }, [_vm._v("\n            Invoice Details\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "row my-5",
    staticStyle: {
      "line-height": "1.5rem"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.formatDateDots(_vm.selectedInvoice.date)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Number")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.selectedInvoice.code))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Client")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.selectedInvoice.name))])]), _vm._v(" "), (_vm.selectedInvoice.bookingRelationsQuantity && _vm.invoiceBookingsArr.length == 0) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Linked to")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold",
    on: {
      "click": _vm.expandBookings
    }
  }, [_c('div', {
    staticClass: "pointer"
  }, [_vm._v("\n                            " + _vm._s(_vm.selectedInvoice.bookingRelationsQuantity) + " Booking" + _vm._s(_vm.selectedInvoice.bookingRelationsQuantity > 1 ? 's' : '') + "\n                            "), _c('span', {
    staticClass: "color-1"
  }, [_vm._v("view list")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.selectedInvoice.type.label))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.selectedInvoice.value)) + "€")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("VAT")]), _vm._v(" "), _c('div', {
    staticClass: "darker bold"
  }, [_vm._v(_vm._s(_vm.selectedInvoice.vatNr))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.invoiceBookingsArr.length > 0) ? _c('div', {
    staticClass: "invoiceBookingsHolder darker bold d-flex"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Linked to")]), _vm._v(" "), _c('div', _vm._l((_vm.invoiceBookingsArr), function(bookingRow) {
    return _c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInvoiceBooking(bookingRow)
        }
      }
    }, [_c('span', {
      staticClass: "color-1"
    }, [_vm._v(_vm._s(_vm.formatTicketNumber(bookingRow.sequencialNumber)))]), _vm._v(" - " + _vm._s(bookingRow.event.product.name))])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-between"
  }, [_c('div', [_c('button', {
    staticClass: "btn tertiary",
    attrs: {
      "disabled": _vm.getIsPrintingInvoice
    },
    on: {
      "click": function($event) {
        return _vm.printInvoiceClicked(_vm.selectedInvoice.id)
      }
    }
  }, [_vm._v("Print")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn tertiary mr-3",
    on: {
      "click": _vm.closeSubModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.selectedInvoice.type.id != 1) ? _c('button', {
    staticClass: "btn action",
    attrs: {
      "disabled": _vm.getIsPrintingInvoice || _vm.getIsCancellingInvoice || _vm.selectedInvoice.bookingInvoiceLinkedId != null
    },
    on: {
      "click": function($event) {
        return _vm.cancelInvoiceClicked(_vm.selectedInvoice)
      }
    }
  }, [_vm._v("Cancelation")]) : _vm._e()])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6faa1986", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6faa1986"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Invoice/InvoiceModal.vue
// module id = 1118
// module chunks = 0